/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import ChannelTable from './ChannelTable';

@observer
class Channels extends Component {
    render() {
        const { match } = this.props;
        return (
            <section>
                <h1>
                    <FormattedMessage id="Channels.Channels" defaultMessage="Channels" />
                    {match.params.type ?
                        (<small>{match.params.type}</small>) : null}
                </h1>
                <ChannelTable store={this.store} match={match} />
            </section>
        );
    }
}

Channels.propTypes = {
    match: PropTypes.object.isRequired,
};

export default injectIntl(Channels);
